var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamgoalsCuate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 635.38 427.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrow--inject-238"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 300.03,
    y: 291.69,
    width: 170.45,
    height: 26.71,
    transform: "translate(-123.61 72.26) rotate(-15.14)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.16,
    y: 317.54,
    width: 17.16,
    height: 26.71,
    transform: "translate(-133.68 48.21) rotate(-15.14)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.09,
    y: 322.51,
    width: 10.58,
    height: 26.71,
    transform: "translate(-135.61 43.58) rotate(-15.14)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.14,
    y: 325.92,
    width: 5.25,
    height: 26.71,
    transform: "translate(-136.94 40.41) rotate(-15.14)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.03 265.32 404.4 222.35 439.95 235.79 416.03 265.32",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hill--inject-238"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M685.28,466.42l-10.4-32.26-27-25.28-13.56-35.8H565.81l-18,7.12-64,2.87L449.64,401.8l-81.35,2.55s-23.05,13.23-24.72,14.2S302,426.62,302,426.62l-35.45,2.69H206.39L149.32,454,79.85,466.52H685.28",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.28,466.42l-10.4-32.26-27-25.28-13.56-35.8H565.81l-18,7.12-64,2.87L449.64,401.8l-81.35,2.55s-23.05,13.23-24.72,14.2S302,426.62,302,426.62l-35.45,2.69H206.39L149.32,454,79.85,466.52H685.28",
    transform: "translate(-57.31 -38.95)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.33 362.85 420.51 373.63 461.87 379.61 434.8 360.21 426.47 344.12 392.33 362.85",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.48 388.35 249.9 403.32 316.5 403.8 347.38 408.88 322.05 392.68 293.79 391.98 286.26 379.61 229.48 388.35",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.01 415 123.75 409.4 146.36 413.17 178.73 404.69 149.08 390.36 92.01 415",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-238"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "7.41 427.47 84.98 427.23 162.55 427.14 317.69 426.97 472.83 427.14 550.4 427.23 627.97 427.47 550.4 427.72 472.83 427.81 317.69 427.97 162.55 427.8 84.98 427.71 7.41 427.47",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-238"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.62,185.8c3,22.9,9.55,45.63,15.94,48.65,8.6,4.06,31.05,3.42,42.68,2,3.42-.42-.35-26.94-4-26.5-4.42.53-27.21,3.64-27.65,3.56-.94-.17-14.82-22.83-18-28.33C190.27,176,185.3,175.63,186.62,185.8Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.52,235.54c3,.61,14.65,1.88,22.69.34,3.9-.75,14.87-4.08,14.52-7.12s-3.63-2.35-3.63-2.35,4.42-2.1,3.79-5.12-5.71-1.79-5.71-1.79,4.39-2.49,3.55-5.46-5.75-.87-5.75-.87,4.12-2.09,2.39-4.24c-2.07-2.6-9.22,2.11-13.57,2.72-1,.14-20.24,1.38-20.24,1.38Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.89,213.15c-5.27,3.45-8.17,4-14.37,4.15-.12,0-.14.19,0,.2,6.08.45,9.82.22,14.56-4.1C270.31,213.18,270.14,213,269.89,213.15Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.44,219.43c-5.79,3.11-8.93,3.79-15.42,4.37-.09,0-.08.17,0,.17,6.41-.05,10.14-.36,15.52-4.22C272.79,219.58,272.7,219.29,272.44,219.43Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.61,226.64c-5.82,2.61-9.23,3.5-15.6,3.26a.12.12,0,0,0,0,.23c6.47.88,10.74-.2,15.69-3.3C274,226.62,274,226.48,273.61,226.64Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.08,212.27s6-5.16,9.09-6.85,17.07-3.7,17.68-.71c.78,3.85-7.05,6.6-11.05,7.45,0,0,1.81,8.92-3.38,12.11S238.08,212.27,238.08,212.27Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.71,205.84c-1.82,4-7.16,4.8-11,5.91a.37.37,0,0,0-.22.56c.51,3.79.13,9.29-2.85,12a.1.1,0,0,0,.12.15c3.59-2.5,4.4-7.87,3.58-12,3.94-1.08,9.25-2.08,10.39-6.64C264.76,205.83,264.73,205.81,264.71,205.84Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.4,209l-1.15,29.7s-31.55,1.43-38.41-5.2c-4.58-4.43-12.75-27.75-14.42-43.74s3.42-15.7,11.75-1.65,15.27,24.42,15.71,24.42S240.4,209,240.4,209Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.85,211.76c0-.09-.14-.09-.15,0a236.66,236.66,0,0,0-1.65,24.81c0,.09.14.09.15,0A236.66,236.66,0,0,0,234.85,211.76Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.62,237.94c-6-.75-11.39-2.09-13.77-4.39-4.59-4.45-12.77-27.76-14.44-43.75-.59-5.72-.32-9.35.66-11Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.8,429.15c-2,.64-59.88-.78-62.05-2.23-.83-.54,6.24-51.84,6.24-51.84l37.22,1-7.33,32.48S244.78,419,247,420.83,250.84,428.53,248.8,429.15Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.81,429.15c-2.05.64-59.89-.77-62.06-2.23-.41-.27,1.07-12.61,2.68-25.18l34.86.58-1.41,6.22S244.78,419,247,420.83,250.84,428.53,248.81,429.15Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.65,429.41c-2.07.66-61-.35-63.23-1.81-.85-.55,1.9-20,1.9-20.11l34.8.47,0,.64s22.39,10.48,24.66,12.35S251.72,428.76,249.65,429.41Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,427.11c-9.93-.41-50-1.14-59.87-.8-.08,0-.09.06,0,.07,9.84.62,49.94,1,59.88.9C249.23,427.27,249.23,427.12,249,427.11Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.35,408.14c-3.9-.8-8.69-.28-11.73,2.45-.11.11,0,.27.17.24a55,55,0,0,1,11.54-2.2A.25.25,0,0,0,227.35,408.14Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.14,409.89c-3.9-.8-8.69-.28-11.72,2.45-.12.11,0,.27.16.24a55.1,55.1,0,0,1,11.54-2.2A.25.25,0,0,0,230.14,409.89Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.94,411.63c-3.9-.79-8.69-.27-11.73,2.46-.12.11,0,.27.16.24a54.58,54.58,0,0,1,11.54-2.2A.25.25,0,0,0,232.94,411.63Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.24,406.68l-39-.21s11.49-80.87,10.49-84.2C197.31,321,155,279.93,155,279.93c-16.86-16.61-11.8-43.41-11.8-43.41h48.61s-2.22,11.84.3,14.43c3.06,3.13,39.74,42.7,44.51,55.31C243,323.09,226.24,406.68,226.24,406.68Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.74,398.94c-6-.39-4.27-.38-10.28-.68-2.94-.15-22.26-1.11-25-.66-.06,0-.07.14,0,.15,2.73.67,22.06,1.22,25,1.29,6,.17,4.29,0,10.3.12C225.84,399.16,225.85,399,225.74,398.94Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.21,253.14,175.79,300.2C165.31,289.92,155,279.93,155,279.93c-16.84-16.61-11.79-43.42-11.79-43.42h48.61s-2.22,11.85.3,14.43C192.47,251.29,193.19,252,194.21,253.14Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.59,464.5c-2.12.25-58.72-11.81-60.58-13.64-.72-.68.56-9,2.39-19.08l.06-.31c.37-2.07,10.34-32.71,10.34-32.71l36.89,4.69-10.63,35.39-.15.62s19.6,14.31,21.44,16.53S163.7,464.27,161.59,464.5Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.58,464.5c-2.11.25-58.71-11.81-60.57-13.64-.72-.69.56-9,2.39-19.08l.06-.31c.1-.54.86-3.35,1.93-7.18l36.64,8-2,6.55-.15.62s19.61,14.31,21.44,16.53S163.7,464.27,161.58,464.5Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.12,464.73c-2.16.24-59.79-12.18-61.68-14.05-.73-.7.59-9.2,2.48-19.43,0-.11,0-.21.07-.32l37.26,7.6-.15.63s19.93,14.62,21.8,16.9S164.28,464.49,162.12,464.73Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,462.35c-9.66-2.33-48.86-10.83-58.59-12.4-.07,0-.09,0,0,.06,9.53,2.52,48.79,10.7,58.57,12.5C162.12,462.55,162.15,462.4,162,462.35Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.37,439.53c-3.67-1.54-8.47-2-12,.14-.14.08,0,.27.11.26a55,55,0,0,1,11.75.08A.25.25,0,0,0,144.37,439.53Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.77,441.79c-3.67-1.54-8.47-2-12,.13-.13.08,0,.28.11.26a55.61,55.61,0,0,1,11.75.09A.25.25,0,0,0,146.77,441.79Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.17,444.05c-3.67-1.54-8.47-2-12,.13-.13.08,0,.27.12.26a54.86,54.86,0,0,1,11.74.09A.25.25,0,0,0,149.17,444.05Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.53,236.52s3.16,27-2.42,33.22c0,0-9.89,62.3-13.43,80.25-4.67,23.69-23.45,88.24-23.45,88.24l-41.32-7s24.37-84.85,24.57-86.4c1.12-8.76,11-69.56,10.5-71.07-5.18-15.45,2.29-37.26,2.29-37.26Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.84,236.52s-3.94,28.59-11.73,33.22c0,0-9.89,62.3-13.43,80.25-4.67,23.69-23.45,88.24-23.45,88.24l-41.32-7s24.37-84.85,24.57-86.4c1.12-8.76,11-69.56,10.5-71.07-5.18-15.45,2.29-37.26,2.29-37.26Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.05,429.73c-6.11-1.37-4.33-1.08-10.46-2.36-3-.63-22.7-4.75-25.61-4.75-.07,0-.09.12,0,.15,2.7,1.11,22.48,4.81,25.49,5.37,6.15,1.15,4.4.74,10.57,1.8C143.13,430,143.17,429.76,143.05,429.73Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.74,266.63a79,79,0,0,0-12.58,5.86c-.16.08-.06.33.11.25,4.24-1.82,8.56-3.56,12.7-5.61A.28.28,0,0,0,185.74,266.63Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.08,237.54c0-.14-.26-.18-.26,0,0,5-.29,9.46-.71,14.16-.2,2.19-2,14.25-5.74,13.37-.64-.15-1-.77-1.06-1.72a15.26,15.26,0,0,1,.5-3.71c.42-2.52.76-5.05,1-7.61a69.45,69.45,0,0,0-.16-14.27.12.12,0,0,0-.24,0,132.45,132.45,0,0,1-1.15,19.71c-.48,3.14-2.06,7.86,1.22,8.34s5.51-7.42,5.92-9.58A72.14,72.14,0,0,0,187.08,237.54Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.47,265.38a19.88,19.88,0,0,0-.85,2.5,5.61,5.61,0,0,0-.36,2.05.14.14,0,0,0,.26.06,6.77,6.77,0,0,0,.88-2c.29-.77.6-1.54.86-2.32A.42.42,0,0,0,180.47,265.38Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.91,253.19c.92-.15,2.26.17,6.25-.11a21.42,21.42,0,0,0,3.27-.53,7.19,7.19,0,0,0,3-1.23,16,16,0,0,0,3.47-4.78,24.78,24.78,0,0,0,2.42-5.89c0-.12.21-.06.19.06-.21,1.16-.33,2.33-.63,3.48a21,21,0,0,1-1.17,3.16,12.73,12.73,0,0,1-3.56,5.26c-1.8,1.35-4.3,1.61-6.48,1.76-1.26.09-6.21-.05-6.87-.75C141.72,253.49,141.73,253.22,141.91,253.19Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.08,247.65c-1.1.78-54.37-11-54.59-11.38-.59-1.15,25.95-54.62,41.15-62.12,3.27-1.61,11.48,1.75,13.16,4.11,1,1.48,2.27,10,3,16.91C197.17,209,194,247,193.08,247.65Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.77,184.14c-.16,5.28-.43,10.56-.72,15.84s-.64,10.55-1,15.83-.75,10.54-1.19,15.81l-.67,7.9c-.25,2.64-.48,5.27-.76,7.9.07-2.64.2-5.28.31-7.93l.4-7.92c.29-5.27.65-10.55,1-15.82s.75-10.55,1.19-15.82S190.22,189.4,190.77,184.14Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.57,200.59a1,1,0,1,1-.94-1A1,1,0,0,1,193.57,200.59Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.68,210.76a1,1,0,1,1-1-1A1,1,0,0,1,192.68,210.76Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.78,220.93a1,1,0,1,1-.94-1A1,1,0,0,1,191.78,220.93Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.88,231.1a1,1,0,1,1-2-.09,1,1,0,0,1,2,.09Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,241.28a1,1,0,0,1-1,.94,1,1,0,1,1,.09-2A1,1,0,0,1,190,241.28Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.48,179.54c-20.2,9.22-36.26,24.33-36.21,31,.07,9.5,8.5,32.91,14.33,43.08,1.7,3,24.68-10.79,22.85-14-2.2-3.86-13.52-26.62-13.61-27.06-.21-.93,15.61-20,19.76-24.6C183.23,179.41,179.47,174.53,168.48,179.54Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.89,271a4.09,4.09,0,0,1-4.57,1,6.12,6.12,0,0,1-2,3.62c-2,1.56-5.26-.83-5.26-.83a7.56,7.56,0,0,1-2.72,3.49c-2,1.3-5.7-.63-5.7-.63a6.58,6.58,0,0,1-4.32,1.57c-4.21-.21-7.36-5.84-9.39-9.4s-4.48-15.56-5.17-17.8l22.72-13.25S182.15,252.1,184,256.63C185.46,260.44,187,268.57,184.89,271Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.59,271.61c-.64-4.44-2.56-8.45-4.24-12.56a.08.08,0,0,0-.14.06c1.72,4.07,2.62,8.42,4.17,12.55A.11.11,0,0,0,180.59,271.61Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.31,274.53a11.39,11.39,0,0,0-1.11-2.85c-.46-1-.93-1.95-1.43-2.92q-1.47-2.89-3.1-5.72c0-.08-.19,0-.14.06,1,1.93,1.93,3.87,2.83,5.84.45,1,.89,2,1.32,3a14.28,14.28,0,0,0,1.36,2.74A.15.15,0,0,0,173.31,274.53Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.6,277.55a8.32,8.32,0,0,0-1.13-2.51c-.47-.87-.93-1.74-1.39-2.62-.92-1.75-1.83-3.5-2.69-5.29,0-.08-.18,0-.14.06.86,1.82,1.69,3.65,2.57,5.45.43.89.86,1.78,1.3,2.66a7.9,7.9,0,0,0,1.39,2.3S164.61,277.59,164.6,277.55Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.21,238.63l-28.65,8.81s-11.83-33.95-9-39.66S151.26,186.44,166,180.1s18.44-1.33,7.48,10.79-17.3,21.22-17.17,21.65S169.21,238.63,169.21,238.63Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.38,233.67c.08,0,0-.17,0-.15a218.92,218.92,0,0,0-22.85,6.7c-.09,0,0,.17,0,.15A219.09,219.09,0,0,0,164.38,233.67Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.31,238.16c-2-4.43-10.16-20.61-12.34-24.94a2.31,2.31,0,0,1-.25-.61,1.41,1.41,0,0,1,.41-1.06c.34-.48.7-1,1.05-1.43.74-1,1.48-2,2.23-3,1.46-1.93,3-3.83,4.47-5.73l.23-.3c1.19-1,2.4-2,3.51-3.12.06,0,0-.14-.09-.1-.95.74-1.84,1.54-2.74,2.35l4.26-5.41a0,0,0,0,0-.05,0c-3.54,3.83-6.83,7.86-10,12-.77,1-1.54,2-2.3,3.07-.38.52-.77,1-1.14,1.55a1.82,1.82,0,0,0-.42.9,2.22,2.22,0,0,0,.37,1.19c.29.61.59,1.23.89,1.84l1.71,3.41c1.28,2.57,8.67,16.94,10,19.46C169.21,238.33,169.35,238.25,169.31,238.16Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.09,185.17c-3.33-.12-7.37-6.37-8.43-10.83-.07-.3,1.11-3,2.39-6.32.76-2,1.57-4.29,2.16-6.41l12.43,6.91a35.1,35.1,0,0,0-3.54,7.8,5.06,5.06,0,0,0-.14.9s0,.09,0,.15C192.75,179.1,191.31,185.29,188.09,185.17Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.8,161.93c-.32,2.77-.92,12.84,6.75,15.14a8.84,8.84,0,0,0,1.38.3.44.44,0,0,0,0-.15,5,5,0,0,1,.15-.9,35.67,35.67,0,0,1,3.55-7.8Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.89,150.28c-.72,5.08,4,18.67,8,21.24,5.7,3.74,13.95,2.88,16.84-3.72,2.81-6.41-3.7-24-8-26.23C191.39,138.28,182,142.79,180.89,150.28Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.82,156.69s-.06.06,0,.1c.34.91.59,2-.14,2.59,0,0,0,.07,0,.05C196.63,158.94,196.29,157.49,195.82,156.69Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.67,156c-1.51.4-.61,3.39.8,3S195.94,155.68,194.67,156Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,155.16s.09,0,.1.06c.25.94.69,2,1.62,2,0,0,.05,0,0,.06C201.63,157.46,201.06,156.09,201,155.16Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.51,153.94c1.46-.57,2.48,2.39,1.12,2.92S200.28,154.41,201.51,153.94Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.08,155c.37-.23.68-.5,1-.76s.74-.49.91-1a.63.63,0,0,0-.33-.73,1.63,1.63,0,0,0-1.63.31,2.42,2.42,0,0,0-1,1.4A.71.71,0,0,0,193.08,155Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.21,152.08a11,11,0,0,1-1.28,0,2.05,2.05,0,0,1-1.32-.2.65.65,0,0,1-.2-.78,1.64,1.64,0,0,1,1.48-.77,2.42,2.42,0,0,1,1.67.46A.7.7,0,0,1,202.21,152.08Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.29,165.65c.29.15.6.39,1,.31a2.62,2.62,0,0,0,.93-.53,0,0,0,0,1,.05,0,1.29,1.29,0,0,1-1,.86,1,1,0,0,1-1-.6C197.19,165.67,197.25,165.63,197.29,165.65Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.43,162.58a3.3,3.3,0,0,0,2.54.77,4.22,4.22,0,0,0,1.15-.29l.21-.09.19-.1a.21.21,0,0,0,.12-.26h0l0-.09h0l0-.08c-.2-.72-.6-1.78-.6-1.78.3.05,1.82.25,1.68-.12a49.44,49.44,0,0,0-4.11-9.2.09.09,0,0,0-.16.08c1,3,2.43,5.73,3.44,8.69a5.57,5.57,0,0,0-1.63,0c-.09.06.8,2,.87,2.38v0a4.63,4.63,0,0,1-3.58,0C197.41,162.44,197.35,162.52,197.43,162.58Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.53,163a3.84,3.84,0,0,1-1.27,1.49,1.72,1.72,0,0,1-1,.28c-.79,0-.95-.72-.94-1.34a4,4,0,0,1,.15-1A5.09,5.09,0,0,0,200.53,163Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.26,164.51a1.72,1.72,0,0,1-1,.28c-.79,0-.95-.72-.94-1.34A1.8,1.8,0,0,1,199.26,164.51Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#ff9cbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.77,156.93c.57-2.82-1.56-7.16-.37-8.55,2.6-3,9.23,1.28,13.35.77s5-3.22,3.86-6.36-4.16-5-8.72-5.06a16.9,16.9,0,0,0-10.8,4.07s.8-1.75.35-2.2-2.19,1.35-2.7,2.09a6,6,0,0,0-.73,2,6.57,6.57,0,0,0-1.85.05,3.83,3.83,0,0,0-2.23,1.36c0,.25,1.44.25,2.46.17,0,0-1.57,2.76-1.26,4.91s5,12,5.81,12C185,162.2,186.53,158.08,186.77,156.93Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.75,145s.09,0,.06.05a6.88,6.88,0,0,0-1.77,3.33,8.54,8.54,0,0,0,.53,4.44,40.5,40.5,0,0,0,4.24,7.61c.05.07-.08.15-.12.08a30.31,30.31,0,0,1-4.59-8.19C177.31,149.8,177.53,146.75,179.75,145Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.11,147.36a9.76,9.76,0,0,1,3.65-.23,14,14,0,0,1,3.3,1.14,13.91,13.91,0,0,0,7.63,1.08s0,0,0,.05a12.15,12.15,0,0,1-7-.59,30.87,30.87,0,0,0-3.43-1.29,12.93,12.93,0,0,0-4.07,0A.11.11,0,0,1,186.11,147.36Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.4,140.35a18.88,18.88,0,0,1,4.9-2.34,15,15,0,0,1,5.14-.84c3,.1,6,1.63,7.05,4.58a6.51,6.51,0,0,1,0,4.68.08.08,0,0,1-.16-.05,6.73,6.73,0,0,0-2.52-7.65c-2.69-1.79-6.11-1.52-9.08-.65a28,28,0,0,0-5.31,2.29S186.39,140.36,186.4,140.35Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.33,162.37a4.09,4.09,0,1,1,2.93-5.75h0a4.08,4.08,0,0,1-2,5.43A4.33,4.33,0,0,1,195.33,162.37Zm-1.43-7.5a4.55,4.55,0,0,0-.84.27,3.55,3.55,0,1,0,.84-.27Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.26,159.5c-1.54.3-3.23-1-3.87-3.05a4.83,4.83,0,0,1,0-3,2.55,2.55,0,0,1,4.16-1.31,4.85,4.85,0,0,1,1.68,2.47c.68,2.15-.07,4.3-1.67,4.81Zm-1.83-7.39-.2,0a2.2,2.2,0,0,0-1.36,1.48,4.37,4.37,0,0,0,0,2.65c.58,1.86,2.12,3,3.44,2.63s1.91-2.27,1.32-4.13a4.35,4.35,0,0,0-1.49-2.19A2.26,2.26,0,0,0,202.43,152.11Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.28,157.11l-.47-.29c.44-.68,1.6-1.78,2.87-1.06l-.27.47C199.27,155.59,198.32,157.05,198.28,157.11Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.22,163.58l-.53-.09c0-.25.45-2.47,1.56-3s8.22-2.06,8.53-2.13l.11.53c-2.06.45-7.6,1.68-8.4,2.08S181.33,163,181.22,163.58Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.5,160.61s-3.95-3.94-5.8-2.46,1.69,7.61,4.25,8.07a2.48,2.48,0,0,0,3-1.89Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.76,159.88s0,.06,0,.07a6.22,6.22,0,0,1,3.88,3.29,1.37,1.37,0,0,0-2.08,0s0,.1.06.08a1.53,1.53,0,0,1,1.75.23,7.86,7.86,0,0,1,1,1.2c.11.14.36,0,.27-.15l0,0C186.3,162.39,184.1,159.69,181.76,159.88Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.94,177.37l-2.6,6.39L180,173l-3,3.11s8.85,16.76,9,16l4.66-6.79,3.57,5.15.39-10.28Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.65,184.52c0-2,.09-2.15,0-4.16,0-.07-.12-.11-.14,0-.51,1.91-.48,7.72-.6,9.55l0,0c-.19-.22-3.26-4.55-3.3-4.49-.79,1.06-4.45,6-4.65,6.47-1.4-2.67-6.79-12.36-8.48-14.9a.07.07,0,0,0-.13.06c1.22,2.8,8.34,15.85,8.46,15.82a62.29,62.29,0,0,0,4.84-7.18c.66.92,3.74,5.77,3.78,5.47A65.87,65.87,0,0,0,194.65,184.52Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-238"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.76,438.76c-2.21.26-61.14-12.3-63.08-14.21-.75-.71.58-9.4,2.49-19.86l.06-.33c.39-2.15,10.77-38.22,10.77-38.22l38.41,9.05L318.34,412l-.15.64s20.41,14.9,22.32,17.22S343,438.52,340.76,438.76Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.24,409.89c-1.38,8-2.18,14.07-1.56,14.66,1.94,1.91,60.87,14.47,63.08,14.21s1.65-6.55-.25-8.86c-1.17-1.41-9.2-7.49-15.3-12,4.09,3.31,10,11.23-15.25,3.13C294.39,416,284.67,412.19,279.24,409.89Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.27,205.82s3.29,28.17-2.52,34.59c0,0-8.94,63.83-12.62,82.52-4.86,24.67-19.73,78.87-19.73,78.87l-42-10.17s21.76-71.4,22-73c1.17-9.12,8-72.44,7.49-74-7.16-20.19,2.38-38.8,2.38-38.8Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.62,390.5c-5.85-1.62-4.14-1.26-10-2.8-2.87-.74-21.77-5.64-24.61-5.73-.06,0-.1.13,0,.16,2.55,1.25,21.56,5.72,24.45,6.4,5.91,1.38,4.24.9,10.17,2.19C322.68,390.75,322.73,390.53,322.62,390.5Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.13,383.54l5.14-21.49,5.21-21.46,2.57-10.75.61-2.68c.18-.89.32-1.8.45-2.71l.79-5.46,2.93-21.9,5.84-43.8,1.47-10.94.75-5.48.21-1.37c0-.19.1-.53.12-.68s0-.44.06-.66c0-.92.06-1.84.08-2.76.1-7.36.06-14.72,0-22.09.15,7.37.3,14.73.31,22.1,0,.92,0,1.84-.05,2.76,0,.24,0,.47-.05.71s-.08.42-.12.68l-.2,1.37-.73,5.47-1.41,10.95-5.62,43.83c-.94,7.31-2,14.6-3,21.89l-.81,5.47c-.15.91-.29,1.82-.48,2.74L331.6,330,329,340.7l-5.35,21.44Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.75,240.41s-3.52,25.09-7,48.41l-35.49-83h45S361.56,234,355.75,240.41Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.74,405c-2.11.7-62.37.23-64.65-1.25-.87-.55,5.6-54.08,5.6-54.08l38.51,1.66L400.39,384s23,10.49,25.33,12.38S429.85,404.28,427.74,405Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.74,405c-.93.31-13.08.39-26.61.26l-2.68,0c-2.31,0-4.64-.06-7-.1l-2.68,0h0l-2.65-.06c-1.35,0-2.67-.05-3.95-.09l-2.47-.07h0l-2.37-.08h0q-1.74,0-3.33-.12c-.71,0-1.41-.05-2.08-.09-1.31-.05-2.51-.12-3.57-.19l-1.5-.11c-1.15-.08-2.08-.18-2.71-.28a3.38,3.38,0,0,1-1-.25c-.3-.19-.11-6.71.27-15.18,5.81,1.36,16.45,3.49,32.73,5.83,26.76,3.85,18.78-3.34,14.24-5.78l-.13-.08.85.4.14.06,1.55.74,1.7.81c.94.45,1.88.9,2.78,1.35s1.77.86,2.59,1.27c.49.25,1,.49,1.42.71.22.1.44.23.66.34s.58.29.85.44c.61.31,1.14.6,1.6.86a1.92,1.92,0,0,1,.31.18,9,9,0,0,1,1.06.67C428,398.21,429.84,404.28,427.74,405Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.45,369l-40.34.49s10-73.16,9-76.62c-.41-1.35-49.34-45.74-49.34-45.74-17.55-17.3-11.51-41.26-11.51-41.26h45s.61,7,3,9.7c13.55,15.2,48.09,46.65,53.38,60.62C421.26,293.67,405.45,369,405.45,369Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.34,221.35a30.09,30.09,0,0,0,1.43,7.89,39.88,39.88,0,0,0,3.15,7.36,59.17,59.17,0,0,0,9.57,12.79c3.68,3.9,7.7,7.49,11.69,11.09s8.08,7.1,12.16,10.61c-2.17-1.59-4.28-3.26-6.41-4.92s-4.17-3.4-6.24-5.14c-4.1-3.49-8.12-7.09-11.89-11a56.71,56.71,0,0,1-9.53-13.11,40.27,40.27,0,0,1-2.95-7.57A28.3,28.3,0,0,1,313.34,221.35Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.8,209.31a21.31,21.31,0,0,0,.37,5.17,8.73,8.73,0,0,0,.83,2.43c.5.7,1.08,1.35,1.64,2,2.28,2.6,4.65,5.14,7,7.68l14.15,15.24q7.08,7.62,14.1,15.31c4.65,5.13,9.3,10.28,13.75,15.62,1.1,1.35,2.18,2.71,3.21,4.12.51.71,1,1.42,1.46,2.19a5.14,5.14,0,0,1,.56,1.26,9.86,9.86,0,0,1,.28,1.31,57.07,57.07,0,0,1,.22,10.45c-.35,6.94-1.09,13.84-1.91,20.73s-1.79,13.75-2.82,20.61-2.19,13.7-3.39,20.53q1.64-10.28,3.05-20.58c1-6.86,1.9-13.73,2.69-20.62s1.48-13.79,1.78-20.7a57.27,57.27,0,0,0-.27-10.32,10.38,10.38,0,0,0-.27-1.23,4.51,4.51,0,0,0-.5-1.1c-.43-.73-.93-1.43-1.44-2.13-1-1.38-2.11-2.73-3.21-4.06-4.39-5.35-9-10.52-13.64-15.68s-9.31-10.28-14-15.38l-14.06-15.34c-2.32-2.58-4.64-5.15-6.88-7.8-.56-.67-1.12-1.33-1.62-2.05a8.77,8.77,0,0,1-.8-2.48A21.5,21.5,0,0,1,347.8,209.31Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.31,359.37c-5.64-.17-4-.23-9.66-.31-2.76,0-20.9-.26-23.48.35-.06,0-.06.14,0,.16,2.58.6,20.72.38,23.48.34,5.64-.08,4-.14,9.66-.31C402.41,359.6,402.41,359.37,402.31,359.37Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.5,188.67l-7-.36a21.43,21.43,0,0,1-1.27-13c.2-1-2.62,4.62-2.29,12.81-7.38-.38-17.42-.9-26.19-1.43.09-3.43,0-6.62,0-6.62a37.6,37.6,0,0,1-1.93,6.51l-3.5-.22a132.82,132.82,0,0,0,.45-14.61A46.91,46.91,0,0,1,324.37,186c-5.56-.4-9.21-.77-9-1,9.14-9,3.4-15,6.43-23.35,3.64-10,12.53-10.92,12.85-18.58.27-6.23.34-17.58,8.38-19.4a15.19,15.19,0,0,1,16.67-1.91c12.06,5.69,5.7,24.5,6.25,28.47.79,5.66,3.29,7.83,4.8,14.33s-1.72,10.64-2.38,15S372.89,188.76,371.5,188.67Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.27,183.63a21.89,21.89,0,0,0,3.11-5.24,11.28,11.28,0,0,0,.41-5.84c-.23-2-.53-4.1-.56-6.23a16.24,16.24,0,0,1,1.1-6.35,14.23,14.23,0,0,1,3.76-5.27,39.08,39.08,0,0,1,5.08-3.7,23.19,23.19,0,0,0,4.73-3.75,11.31,11.31,0,0,0,2.65-5.4,10.55,10.55,0,0,1-2.07,5.87,21.06,21.06,0,0,1-4.61,4.29,47.26,47.26,0,0,0-4.75,3.79,13.67,13.67,0,0,0-3.28,4.78,15.83,15.83,0,0,0-1,5.75c0,2,.18,4,.29,6.11a21.15,21.15,0,0,1,0,3.18,9.44,9.44,0,0,1-.94,3.11A17.74,17.74,0,0,1,315.27,183.63Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.22,129.45a31.05,31.05,0,0,1,1.13,7.55c.13,2.55.13,5.1.11,7.63l0,3.79a18.9,18.9,0,0,0,.3,3.64,20.21,20.21,0,0,0,2.91,6.68,29.77,29.77,0,0,1,1.78,3.47,18.14,18.14,0,0,1,1.1,3.82,25.89,25.89,0,0,1,.25,3.92,16.28,16.28,0,0,1-.51,3.92c-.32,1.28-.78,2.48-1.17,3.65a19.74,19.74,0,0,0-.86,3.61,7.78,7.78,0,0,0,2.57,6.65,7.91,7.91,0,0,1-3.36-6.71,19.94,19.94,0,0,1,.62-3.85c.32-1.25.73-2.44.95-3.64a20,20,0,0,0,0-7.28,17.48,17.48,0,0,0-1.05-3.46,28.51,28.51,0,0,0-1.72-3.27,38.23,38.23,0,0,1-1.83-3.42,15.76,15.76,0,0,1-1.19-3.81,20.12,20.12,0,0,1-.2-3.93c0-1.29.09-2.55.17-3.82.13-2.53.31-5.05.37-7.58A36.8,36.8,0,0,0,366.22,129.45Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.78,167.15c7.33,20.5,20.76,37.45,27.24,37.95,9.29.72,28.34-3.6,38.75-8.44,3.06-1.43-7.26-24.54-10.54-23-4,1.83-23.84,8.55-24.27,8.6-.93.13-18.21-16.9-22.4-21.35C352.88,152.74,347.8,156,351.78,167.15Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.3,197.82c3-.24,14.24-2.21,21.36-5.83,3.45-1.76,12.83-7.87,11.68-10.62s-4-1.21-4-1.21,3.58-3.17,2.17-5.84-5.84-.12-5.84-.12,3.44-3.52,1.85-6.08-5.63.74-5.63.74,3.3-3.07,1.1-4.63c-2.65-1.87-8.08,4.49-12,6.24-.89.4-18.6,6.79-18.6,6.79Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.76,168.87c-4,4.66-6.56,6-12.35,7.79-.11,0-.08.21,0,.18,5.82-1.22,9.27-2.45,12.54-7.79C435.15,168.79,435,168.64,434.76,168.87Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.85,174.07c-4.58,4.48-7.35,6-13.27,8.28-.08,0,0,.17.05.15,6-1.78,9.42-3.09,13.41-8.17C439.22,174.1,439.05,173.86,438.85,174.07Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.9,180.51c-4.75,4-7.71,5.78-13.74,7.28a.12.12,0,0,0,0,.23c6.3-.94,10-3.11,13.81-7.35C442.26,180.38,442.2,180.26,441.9,180.51Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.69,176.68s4.19-6.46,6.66-8.89,15-8.11,16.38-5.47c1.79,3.4-4.81,8.1-8.33,10,0,0,4.12,7.87.12,12.27S404.69,176.68,404.69,176.68Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.92,163.42c-.62,4.27-5.41,6.44-8.7,8.52a.35.35,0,0,0-.05.58c1.51,3.42,2.64,8.68.59,12-.06.09.08.19.15.1,2.69-3.31,2-8.57.1-12.2,3.41-2.08,8.12-4.47,7.95-9.05A0,0,0,1,0,427.92,163.42Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.93,178l5.62,25.92s-16.9,4.89-22.25,1.64-19.21-21-24.17-36,.22-18.12,11.16-6.42,19.29,18.67,19.72,18.58S392.93,178,392.93,178Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.6,180.79c0-.08-.16,0-.15,0a212.85,212.85,0,0,0,4.65,22.89c0,.08.16,0,.14,0A215.1,215.1,0,0,0,388.6,180.79Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.48,206.58c-3.31.25-6.38.07-8.17-1-5.35-3.25-19.21-21-24.18-36-3.59-10.82-1.88-15.46,3.48-12.79Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.17,195.6l-2.9,10.23h-45s10-36.32,27.1-47.49c8.55-5.59,14.38-3.06,18.11,3.3.94,1.61,8,17.18,8.33,23.85A11,11,0,0,1,361.17,195.6Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.13,202.79,358.8,204h-45q.15-.53.36-1.17Zm-43.92-3.3c-.13.4-.26.79-.39,1.16h44.92l.33-1.16Zm1.17-3.31c-.15.4-.29.78-.42,1.16h44.72l.33-1.16Zm1.25-3.31c-.16.39-.31.78-.46,1.17h46.11a10.42,10.42,0,0,0,1.09-1.17Zm1.31-3.3-.47,1.16h47.26a8,8,0,0,0,.47-1.16Zm1.42-3.31-.51,1.16h46.84a8.71,8.71,0,0,0,.07-1.16ZM366.41,183H321.88c-.19.39-.37.78-.55,1.17h45.29C366.56,183.75,366.5,183.36,366.41,183Zm-.82-3.31H323.52l-.6,1.17h43C365.81,180.43,365.7,180,365.59,179.64Zm-1-3.3H325.29l-.65,1.16h40.29Zm-1.2-3.31H327.23c-.24.39-.48.77-.71,1.17h37.26C363.64,173.81,363.49,173.42,363.34,173Zm-1.29-3.31H329.39c-.27.39-.54.78-.79,1.17h33.92Zm-1.39-3.3H331.83c-.31.38-.61.76-.9,1.16h30.23Zm-1.49-3.31H334.7c-.37.38-.72.77-1.08,1.17h26.09Zm-2-3.31H338.29q-.71.55-1.38,1.17H358C357.77,160.56,357.5,160.17,357.21,159.8Zm-3.58-3.3h-10a20,20,0,0,0-2.24,1.16h13.84A9.36,9.36,0,0,0,353.63,156.5Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#030402",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.4,192.15a24.28,24.28,0,0,0-5.07.93c-.83.26-1.65.58-2.47.93-.41.17-.82.32-1.23.47a3.85,3.85,0,0,1-1.31.28s0,.09,0,.09a5.72,5.72,0,0,0,1.24,0,6.27,6.27,0,0,0,1.2-.26c.85-.25,1.69-.57,2.53-.83,1.7-.54,3.41-1.08,5.12-1.44C356.48,192.34,356.48,192.14,356.4,192.15Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.39,194.63a25.11,25.11,0,0,0-4.14-.55,16.22,16.22,0,0,0-2.09.06c-.33,0-.67.06-1,.11s-.73.17-1.1.2c0,0,0,.1,0,.1a8.88,8.88,0,0,1,1,0l1,0,2.09,0c1.39,0,2.77,0,4.16.13C360.46,194.8,360.46,194.64,360.39,194.63Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.06,156.29c-22.26,2.34-39.73,9.43-45.78,12.65-3.95,2.1-25.92,17.6-30.93,22.2-2.45,2.25,13.09,20.73,16,18.63,3.9-2.85,28.16-24.69,28.5-25C311.13,183.76,337,168,342.43,165,351.45,160.05,351.94,155.25,342.06,156.29Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.85,232.17a4,4,0,0,1-2.54-3.75,5.91,5.91,0,0,1-4-.48c-2.12-1.19-1.17-5-1.17-5a7.32,7.32,0,0,1-4.12-1.17c-1.91-1.35-1.51-5.35-1.51-5.35a6.39,6.39,0,0,1-3-3.32c-1.35-3.86,2.57-8.73,5-11.85s12.36-9.66,14.12-11.1l14.6,19.65s-1.49,13.09-4.91,16.35C273.54,228.86,266.78,233.18,263.85,232.17Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.74,228.53c3.75-2.18,6.66-5.36,9.74-8.36.07-.07,0-.18-.1-.11-3,3-6.62,5.41-9.77,8.31C261.52,228.45,261.64,228.59,261.74,228.53Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.47,223.05a10.94,10.94,0,0,0,2.16-2q1.06-1.16,2.1-2.34,2.07-2.38,4-4.86c.05-.08-.05-.18-.11-.11-1.38,1.58-2.78,3.14-4.22,4.66-.72.76-1.45,1.51-2.18,2.26a13.38,13.38,0,0,0-2,2.22A.15.15,0,0,0,256.47,223.05Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.59,216.32a7.72,7.72,0,0,0,1.85-1.93c.61-.74,1.23-1.47,1.85-2.2,1.24-1.46,2.48-2.91,3.78-4.33a.07.07,0,0,0-.11-.1c-1.32,1.43-2.66,2.84-4,4.28-.65.71-1.28,1.42-1.92,2.14a7.19,7.19,0,0,0-1.56,2.08S250.56,216.34,250.59,216.32Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.38,204.21l-18.31-21.92s16.81-11.39,22.05-14.55,26.53-10.49,42.06-11.74,15.13,3.68,1.32,11.42-23.73,14.34-24,14.66C314.6,183,292.38,204.21,292.38,204.21Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.32,197.76c.06.06.17,0,.12-.1a212.61,212.61,0,0,0-15-17.55c-.06-.06-.16,0-.11.1A214.15,214.15,0,0,0,296.32,197.76Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.33,181.37c1.75-1.23,3.55-2.4,5.35-3.55s3.64-2.26,5.45-3.39,3.68-2.19,5.54-3.25,3.73-2.1,5.63-3.08c-1.75,1.24-3.55,2.4-5.35,3.56s-3.63,2.25-5.45,3.38-3.67,2.19-5.54,3.25S318.24,180.39,316.33,181.37Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.83,171.52a14.19,14.19,0,0,1,2.27-1,18.65,18.65,0,0,1,2.39-.64,6.2,6.2,0,0,1-1.08.63,11,11,0,0,1-3.58,1Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.75,160.12c.3.93,5.31,6.7,9.61,6.15,1.41-.18.76-7.88.76-7.88l.08-.58,1.14-8.11-9.85-5.25-1.41-.69s-.17,2.24-.35,5c0,.13,0,.26,0,.4s0,.31,0,.45c0,.42-.06.85-.08,1.27s0,.64,0,1l0,1A52.92,52.92,0,0,0,348.75,160.12Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.73,148.79a16.43,16.43,0,0,0,10.47,9l1.14-8.11-9.85-5.25-1.41-.69S348.91,146,348.73,148.79Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.73,134.18c4.78,13.55-2.79,17.95-5.72,19-2.65.93-11.81,3.77-18-9.22s-1.37-19.49,4.59-22S365,120.62,369.73,134.18Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367,133.67a8.21,8.21,0,0,1-.88.46,1.55,1.55,0,0,1-1,.3.51.51,0,0,1-.4-.48,1.26,1.26,0,0,1,.78-1,1.8,1.8,0,0,1,1.32-.24A.55.55,0,0,1,367,133.67Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.85,137c.33-.08.62-.22.94-.33a1.68,1.68,0,0,0,.89-.52.51.51,0,0,0-.09-.62,1.26,1.26,0,0,0-1.27-.13,1.87,1.87,0,0,0-1.08.81A.55.55,0,0,0,357.85,137Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.69,138.62s-.06.07-.05.11c.31.93.51,2-.24,2.61a0,0,0,0,0,0,0C361.41,140.93,361.13,139.45,360.69,138.62Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.55,137.9c-1.54.34-.74,3.39.68,3.08S360.85,137.61,359.55,137.9Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,138.21c-.23.25-.41.62-.72.73s-.73-.11-1-.35c0,0-.06,0-.05,0,.15.58.53,1.13,1.18,1.05s.87-.69.86-1.32C359.22,138.25,359.08,138.12,359,138.21Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.73,136.66s.08,0,.09.07c.24,1,.66,2,1.6,2.08,0,0,0,.05,0,.05C366.35,139,365.8,137.6,365.73,136.66Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.3,135.44c1.48-.53,2.44,2.48,1.07,3S365.05,135.89,366.3,135.44Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.94,135.42c.32.08.67.3,1,.23s.55-.48.7-.86c0,0,0,0,.06,0a1.15,1.15,0,0,1-.43,1.52,1.18,1.18,0,0,1-1.44-.65C366.77,135.57,366.81,135.38,366.94,135.42Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.45,146c.28.18.57.44.93.39a2.45,2.45,0,0,0,1-.46s.06,0,.05,0a1.33,1.33,0,0,1-1.11.78,1,1,0,0,1-.93-.69C362.34,146,362.41,145.94,362.45,146Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.47,141.48s.58,1.36.76,2c0,.06-.13.13-.35.21h0a3.26,3.26,0,0,1-3.39-.34c-.07,0,0-.15.07-.12a4.94,4.94,0,0,0,3.11,0c0-.2-1.07-2.29-1-2.33a5.92,5.92,0,0,1,1.6-.07c-1.12-2.86-2.69-5.52-3.77-8.39,0-.1.11-.17.16-.09a49.72,49.72,0,0,1,4.45,8.87C367.28,141.65,365.77,141.52,365.47,141.48Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.71,143.49a3.9,3.9,0,0,1-1.16,1.66,1.76,1.76,0,0,1-1,.39c-.82,0-1-.65-1.1-1.29a4.25,4.25,0,0,1,.06-1A5.16,5.16,0,0,0,365.71,143.49Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.55,145.15a1.76,1.76,0,0,1-1,.39c-.82,0-1-.65-1.1-1.29A1.88,1.88,0,0,1,364.55,145.15Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#ff9cbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.31,144.16c3.31-1,1.59-6.25,1.59-6.25s3.64-1.57,1.94-7.71a9.61,9.61,0,0,0,8.32,2.15c1.13-.19-3.39-1.8-3.39-1.8s5.6,2.5,13.13-1.6c.54-.29-3.43-8.36-10.67-9.19s-12.37,2.65-15,7.89a8,8,0,0,0-2.09,7.27C341.07,139.46,345,144.57,346.31,144.16Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.37,143.66s-4.16-3.56-5.85-2,2.21,7.3,4.75,7.57a2.43,2.43,0,0,0,2.83-2.08Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.68,143.3a0,0,0,0,0,0,.07,6.15,6.15,0,0,1,4,2.93,1.34,1.34,0,0,0-2,.14s0,.1.07.08a1.49,1.49,0,0,1,1.72.09,7.56,7.56,0,0,1,1.1,1.09c.11.13.35,0,.25-.17l0,0C349.31,145.42,347,142.94,344.68,143.3Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-238"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M516.85,123.48c6.74,17.63,25.44,41,30.11,42.71,7.42,2.7,30.95-6.8,39.87-11.54,2.68-1.43-8.78-25.38-11.51-23.63-5.79,3.71-21.63,10.34-23.7,10.18-1.38-.11-16.14-13.32-25.3-21.09C514.73,110.28,515.08,118.85,516.85,123.48Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532,152.33l8.64-22.08a134.6,134.6,0,0,0-17.9-14.33c-8.9-5.66-9.35,3.43-2.63,16S532,152.33,532,152.33Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.19,146.37c1.67-4.85,3.68-9.59,5.78-14.27.59-1.33,1.21-2.64,1.87-3.93,0,0,.08,0,.06,0-.88,2.4-1.87,4.76-2.83,7.14s-2,4.75-3,7.1c-.58,1.33-1.17,2.65-1.78,4C529.25,146.46,529.17,146.43,529.19,146.37Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537,139.5l-5,12.84s-5.17-7.83-11.89-20.41c-3.65-6.85-5.19-12.65-4.4-15.62C521.12,122.15,531.19,133.09,537,139.5Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579,155.18c-3.13-.8-6.84-21.05-4.55-23.45a12.91,12.91,0,0,1,2.77-1.83h0a46.92,46.92,0,0,0,7.21-11.67c2-5.11,4.4-12.92,7.18-11.94,4.07,1.41,2.23,11.64.82,17.46,3.13-.88,5.91-1.35,7.63-1,5.7,1.07,7.36,22.9,2.79,26.63S582.1,156,579,155.18Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.24,
    y: 38.64,
    width: 2.32,
    height: 270.7,
    transform: "translate(-68.93 7.82) rotate(-4.42)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.22,122.13c-1.14,2.79,2.81,2.54,2.81,2.54s-5.59,1.73-5.65,5.07,4.7,2.73,5,2.7c-.3.1-5.39,1.82-5.1,5.18s5,2.19,5.28,2.11c-.25.17-3.52,2.56-2.72,5.06,1.36,4.3,9.89-1.58,13.45-.77,0,0-1.83,6.54-1.81,6.73,0,0,9.37-5.78,10.2-10.64a3.16,3.16,0,0,0-1.87-3.48s2.85-1.45,2.71-4.1c-.08-1.36-2.32-2.45-2.32-2.45a3.94,3.94,0,0,0,2-3.61c-.21-1.87-2.42-2.68-2.42-2.68s1.58-2.2.74-4.05C607.84,116,591.67,116.16,589.22,122.13Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.45,123.61a0,0,0,1,0,0-.08,28.11,28.11,0,0,0-16.65,1.13c-.16.07-.12.37.07.33A57.71,57.71,0,0,1,608.45,123.61Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.32,130.05c.07,0,.07-.1,0-.12a26.28,26.28,0,0,0-18.09,2.36c-.19.11-.25.4,0,.29C595.08,130.78,604.11,129.64,609.32,130.05Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.29,140.08c5.45-2.81,11.26-3.58,17.34-3.52.08,0,.07-.11,0-.13-3-.84-6.84-.47-9.83.07a16.09,16.09,0,0,0-7.61,3.39C591.1,140,591.17,140.14,591.29,140.08Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.94,124.62c-.2.08.14.28-.06.37-.83.38-5.62,3.09-5.21,5,.34,1.54,2.64,2.16,3.62,2.05l2.45-.28-2.21,1.11a10.28,10.28,0,0,0-2.66,1.91,3.63,3.63,0,0,0-1.21,2.7,2.06,2.06,0,0,0,1.66,2,6.08,6.08,0,0,0,3.12-.23l2.8-.84-2.36,1.71a9.88,9.88,0,0,0-1.77,1.65,3.93,3.93,0,0,0-1,2.05,1.84,1.84,0,0,0,.86,1.76,4.06,4.06,0,0,0,2.28.3,32.38,32.38,0,0,0,5-1.09c.83-.22,1.66-.45,2.5-.63a6.2,6.2,0,0,1,2.57-.15,6.53,6.53,0,0,0-2.51.38c-.82.25-1.62.53-2.43.81a27.88,27.88,0,0,1-5,1.39,4.8,4.8,0,0,1-2.75-.28,2.63,2.63,0,0,1-1.37-2.55,4.78,4.78,0,0,1,1.12-2.57,10.48,10.48,0,0,1,1.94-1.88l.44.87a7.28,7.28,0,0,1-3.69.31,3,3,0,0,1-1.72-1.06,3.35,3.35,0,0,1-.68-1.89,4.59,4.59,0,0,1,1.53-3.42,11.37,11.37,0,0,1,3-2l.25.84c-1.25.1-3.89-.31-4.72-2.63C585.07,127.1,590.85,124.94,591.94,124.62Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592,124.67a5.89,5.89,0,0,1-1.78-.52,1.37,1.37,0,0,1-.83-1.14,2.78,2.78,0,0,1,.52-1.53c.33-.52.7-1,1.1-1.56a4.74,4.74,0,0,0-1.62,1.16,2.84,2.84,0,0,0-.85,2,2,2,0,0,0,.47,1.11,2,2,0,0,0,1,.59A3.23,3.23,0,0,0,592,124.67Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.7,324.14s-6.54,36.77-6.55,36.79c-1,7.07-1.8,13.29-1.9,16.55v0a4.89,4.89,0,0,0,.21,2.26l0,0c1.9,1.73,58.18,11.58,60.25,11.26s1.34-6.27-.54-8.39-21.75-15.53-21.75-15.53l6.06-36.83Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.21,353.33s-1,7.58-1.06,7.6c-1,7.07-1.8,13.29-1.9,16.55v0a9.49,9.49,0,0,0,.21,2.26l0,0c1.9,1.73,58.18,11.58,60.25,11.26s1.34-6.27-.54-8.39-21.75-15.53-21.75-15.53l1.19-7.7Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.7,391.31c-2.11.32-59.31-9.67-61.25-11.43-.74-.66-.06-9.63,2.43-19.25l36.86,6.49s19.48,13.5,21.4,15.66S553.82,391,551.7,391.31Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.28,388.88c-9.55-1.91-48.23-8.71-57.82-9.88-.07,0-.08.05,0,.06,9.42,2.1,48.17,8.59,57.8,10C551.46,389.06,551.48,388.92,551.28,388.88Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.82,380.08a7.8,7.8,0,0,0-6.14,1.34,7.55,7.55,0,0,0-3,4.74c0,.06.1.08.12,0a9,9,0,0,1,9-6C547.88,380.2,547.9,380.09,547.82,380.08Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.58,368.6c-3.82-.72-8.51-.14-11.44,2.58-.12.1,0,.26.16.23a53.35,53.35,0,0,1,11.27-2.32A.25.25,0,0,0,532.58,368.6Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.35,370.27c-3.83-.72-8.52-.14-11.45,2.58-.12.11,0,.27.16.23a53.35,53.35,0,0,1,11.27-2.32A.25.25,0,0,0,535.35,370.27Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.11,372c-3.83-.73-8.52-.15-11.45,2.57-.11.11,0,.27.16.23a54,54,0,0,1,11.27-2.32A.24.24,0,0,0,538.11,372Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.87,373.62c-3.83-.72-8.52-.15-11.45,2.58-.11.1,0,.26.16.22a54,54,0,0,1,11.27-2.32A.24.24,0,0,0,540.87,373.62Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.81,168.83s7,93.1,7.23,94.42c0,.12-18.79,95.17-18.79,95.17L532,365.48s13.47-91.62,13.59-101.74c.21-17.34-2.32-69.36-8.7-94.91Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.87,355.49c-1-.42-25.26-5.15-34.77-6.09-.1,0-.34.23,0,.35,2.58.91,34.13,6.05,34.74,6C531.94,355.76,532,355.53,531.87,355.49Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.16,176c-.15-1.08-.34-2.16-.53-3.24,0-.16-.3-.12-.28.05.34,4.66,1,9.31,1.5,14s6.42,74.81,6.2,77.11a53.13,53.13,0,0,1-1.25,6.73c-1.07,4.54-13.22,63.85-15.52,72.91-.29,1.14-.52,2.28-.75,3.43a.11.11,0,0,0,.21,0c1.59-4.44,18.5-78.71,18.58-83.29S513.45,185.43,512.16,176Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.34,248.78l-38.29-23.85c-2-26.17-4.24-56.1-4.24-56.1h34.06C542,189.31,544.82,226.57,545.34,248.78Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.47,316.34s-2.3,37.29-2.3,37.32c-.48,7.13-.77,13.39-.62,16.64a.07.07,0,0,0,0,.05,5,5,0,0,0,.37,2.24l0,.05c2,1.58,58.9,7.05,60.95,6.57s.85-6.35-1.19-8.32-22.88-13.81-22.88-13.81l1.94-37.3Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.64,346s-.47,7.63-.47,7.66c-.48,7.13-.77,13.39-.62,16.64a.07.07,0,0,0,0,.05,9.93,9.93,0,0,0,.37,2.24l0,.05c2,1.58,58.9,7.05,60.95,6.57s.85-6.35-1.19-8.32-22.88-13.81-22.88-13.81l.58-7.76Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.17,379.11c-2.07.52-60-3.91-62.07-5.47-.8-.59-1-9.58.56-19.39l37.32,2.9s20.69,11.56,22.81,13.52S619.24,378.59,617.17,379.11Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.52,376.73c-9.69-1-48.85-4-58.5-4.25-.08,0-.09,0,0,.06,9.58,1.18,48.77,3.9,58.5,4.35C616.71,376.9,616.72,376.75,616.52,376.73Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.23,368.31a7.83,7.83,0,0,0-6,1.92,7.6,7.6,0,0,0-2.57,5c0,.06.11.07.12,0a9,9,0,0,1,8.43-6.83A.06.06,0,0,0,612.23,368.31Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596,358.35c-3.88-.35-8.49.68-11.14,3.67-.11.12.06.26.18.21a54,54,0,0,1,11-3.39A.25.25,0,0,0,596,358.35Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.86,359.75c-3.88-.35-8.49.68-11.14,3.67-.11.12.06.26.18.21a53.37,53.37,0,0,1,11-3.39A.25.25,0,0,0,598.86,359.75Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.77,361.15c-3.88-.35-8.49.68-11.14,3.67-.11.11.06.26.18.21a54,54,0,0,1,11-3.4A.24.24,0,0,0,601.77,361.15Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.68,362.55c-3.88-.35-8.49.67-11.14,3.67-.11.11.06.26.18.21a54,54,0,0,1,11-3.4A.24.24,0,0,0,604.68,362.55Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.26,351.26l41.92,3.84s11.57-112.35,7.49-124.37c-5.39-15.92-75.41-38.37-73.64-40.63,0,0,3.34-13.48,6.85-21.27H485.43c-6.93,20.43-3,34.89-.61,39C496.06,227,564.93,246.94,564.23,252,563.11,259.9,554.26,351.26,554.26,351.26Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.31,345.72c-1-.32-25.64-2.72-35.19-2.75-.1,0-.32.26,0,.35,2.65.66,34.55,2.77,35.15,2.68C593.4,346,593.41,345.75,593.31,345.72Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.84,189.42c-.67,0-1.33,0-2,0s-1.33.12-2,.2c-1.29.16-2.56.43-3.83.71a38,38,0,0,0-7.45,2.38c-.08,0,0,.16.06.14,2.56-.52,5.08-1.18,7.63-1.71,1.24-.25,2.48-.45,3.72-.7.65-.13,1.31-.27,2-.38s1.29-.32,1.94-.44C536,189.64,536,189.41,535.84,189.42Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.92,168.88c0-.06-.08-.06-.09,0a94.54,94.54,0,0,1-2,13.49,5.83,5.83,0,0,1-1.29,2.79c-.4.41-.92.75-1.45.37a1.82,1.82,0,0,1-.61-1.54,36.94,36.94,0,0,1,.46-3.77c.14-1.19.24-2.38.34-3.57.24-2.87.23-4.74.33-7.61,0-.1-.15-.1-.15,0-.17,3-.63,4.94-1,7.89-.19,1.43-.4,2.85-.6,4.28-.18,1.23-.62,2.68-.22,3.91a2.25,2.25,0,0,0,1.71,1.55l-.09.22-.44,1.07c-.28.7-.54,1.42-.85,2.11,0,.1.08.2.15.11a6,6,0,0,0,1.21-2,9.58,9.58,0,0,0,.47-1.52,3.3,3.3,0,0,0,2.21-2,12.09,12.09,0,0,0,.91-3.29c.26-1.45.47-2.91.65-4.37A44.74,44.74,0,0,0,535.92,168.88Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.31,172.77c0-.16-.28-.14-.32,0-.26,1.17-.35,2.38-.52,3.57s-.36,2.33-.62,3.47a12.67,12.67,0,0,1-2.46,5.58c-2.87,3.33-7.79,4.2-12,4.13-.1,0-.09.14,0,.15,3.68.4,7.53.63,10.79-1.45,3.06-2,4.25-5.32,4.8-8.75A20.45,20.45,0,0,0,512.31,172.77Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.58,195.34a51.5,51.5,0,0,0-6-2.82c-2-.81-4.09-1.42-6.11-2.2-.08,0-.14.11-.06.14,2,.9,4,1.95,6,2.81a51.15,51.15,0,0,0,6.11,2.2C541.61,195.49,541.65,195.37,541.58,195.34Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.09,236.5c-2-1.18-34.78-15.27-36.81-16.37s-4.1-2.3-6.12-3.51A104.3,104.3,0,0,1,497,209.08a24,24,0,0,1-7.82-9.91,33.66,33.66,0,0,1-1.83-12.52,96.07,96.07,0,0,1,1.48-16.32.08.08,0,0,0-.15,0,124.29,124.29,0,0,0-2,14.78,37.28,37.28,0,0,0,1.14,13,22.69,22.69,0,0,0,6.95,10.45A74.1,74.1,0,0,0,506,216.32c2.31,1.4,4.67,2.7,7.07,3.94s35.46,15.64,38,16.47C551.14,236.78,551.21,236.57,551.09,236.5Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.2,247c-.58-1.16-27.07-13.5-29.24-14.05-.1,0-.21.36-.12.4,1.45.6,28.13,13.43,28.51,14,.8,1.2-7.55,89.15-7.54,90a.21.21,0,0,0,.42,0C564.71,335.82,572.88,248.35,572.2,247Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.48,185.45c.15.15,59.75-3.3,60.27-3.94.73-.9-15.61-59.06-22.09-66.83-1.39-1.67-5.75-2-9.43-1.35a16.87,16.87,0,0,0-2.82.69l-.09,0a7,7,0,0,0-2.05,1.11c-9.94,8.63-16.91,33.94-18.58,42.63C482.93,172.11,480,184.91,480.48,185.45Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.12,159.71a6.26,6.26,0,0,0-1.22.23,7.61,7.61,0,0,0-2.69,1.47,13.29,13.29,0,0,0-2.66,3.28c-.08.12-.15.24-.22.37-.3.5-.57,1-.84,1.55l-.13.27a2.39,2.39,0,0,0-.13.28c-.88,1.79-1.65,3.64-2.49,5.48a17.67,17.67,0,0,1-3.64,5.64,5.1,5.1,0,0,1-3.1,1.42,10.24,10.24,0,0,1-3.35-.46,17.85,17.85,0,0,1-5.69-3.46l-.85-.73c-.26-.21-.51-.43-.76-.65-1-.88-2-1.75-3.07-2.55l-.41-.3-.44-.32a11.84,11.84,0,0,0-5.36-2.3,13.73,13.73,0,0,0-1.57-.05c-.53.06-1.05.16-1.57.25a11.39,11.39,0,0,0-2.89,1.25h0c-.29.18-.57.36-.85.57a38.47,38.47,0,0,0-3.42,2.91l-.59.53-.19.17a19.34,19.34,0,0,1-5.37,3.45c0-.21.08-.42.13-.64a20.78,20.78,0,0,0,4.71-3.37l0,0,.53-.49c1.14-1.05,2.25-2.17,3.52-3.13a9.34,9.34,0,0,1,.82-.58l.22-.15a9.82,9.82,0,0,1,6.61-1.53,12.41,12.41,0,0,1,5.73,2.75l.31.24c.16.13.32.26.48.41,1,.85,2,1.75,2.95,2.64l.73.66c.27.24.54.48.82.71a15.71,15.71,0,0,0,5.57,3.39,8.72,8.72,0,0,0,3.2.36,4.61,4.61,0,0,0,2.77-1.39,18.07,18.07,0,0,0,3.29-5.57c.77-1.81,1.49-3.67,2.33-5.48a2.39,2.39,0,0,1,.13-.28c0-.12.1-.23.16-.35.33-.67.68-1.34,1.07-2a3.79,3.79,0,0,1,.2-.34,13.71,13.71,0,0,1,2.62-3.24,7.87,7.87,0,0,1,3.08-1.69,9.83,9.83,0,0,1,1.2-.25C534.92,159,535,159.37,535.12,159.71Zm3.42,12.14c-.29,0-.58,0-.86,0a13.09,13.09,0,0,1-1.53-.36,10.36,10.36,0,0,1-3.45-2c-.3-.26-.59-.54-.87-.82s-.56-.58-.83-.88c-.86-1-1.66-2-2.45-3-.21-.28-.42-.56-.64-.83-.34-.45-.69-.91-1-1.35A17.87,17.87,0,0,0,522,158a9.82,9.82,0,0,0-3.18-1.13,5.17,5.17,0,0,0-3.32.75,17.77,17.77,0,0,0-4.71,4.8c-1.33,1.78-2.56,3.62-3.92,5.33a22.14,22.14,0,0,1-3,3.14c-.15.13-.31.25-.47.37a9.45,9.45,0,0,1-1.26.83,7.5,7.5,0,0,1-2.93.89,8.86,8.86,0,0,1-3.09-.37,12.49,12.49,0,0,1-4.11-2.2c-.24-.19-.47-.39-.7-.59l-.57-.53a29.35,29.35,0,0,1-4-5.14c-.59-.92-1.17-1.85-1.75-2.79-.07.33-.13.67-.2,1,.42.74.84,1.48,1.29,2.21a30.69,30.69,0,0,0,4,5.41,5.77,5.77,0,0,0,.44.42,7.32,7.32,0,0,0,.66.59,13.37,13.37,0,0,0,4.68,2.6,9.55,9.55,0,0,0,3.46.44,8.08,8.08,0,0,0,3.36-1,11.19,11.19,0,0,0,1.6-1.12,4.35,4.35,0,0,0,.41-.34,22.7,22.7,0,0,0,2.92-3.21c1.37-1.77,2.56-3.65,3.82-5.45a17.85,17.85,0,0,1,4.35-4.79,4.65,4.65,0,0,1,3-.79,8.64,8.64,0,0,1,3.05,1,15.45,15.45,0,0,1,4.77,4.45c.38.48.74,1,1.11,1.47l.62.86c.72,1,1.45,2,2.24,3l.08.09.59.69a11.92,11.92,0,0,0,4.64,3.38,9.23,9.23,0,0,0,2.89.53C538.69,172.45,538.62,172.15,538.54,171.85Zm-.56-2a18.44,18.44,0,0,1-6.15-1.22l-1.18-.43c-1.1-.41-2.19-.85-3.29-1.27l-.88-.33a18.29,18.29,0,0,0-8.9-1.36,8,8,0,0,0-5,2.88c-1.29,1.48-2.28,3.12-3.47,4.55a13.84,13.84,0,0,1-1.43,1.53l-.29.25a9.77,9.77,0,0,1-2.53,1.58,13.31,13.31,0,0,1-5.37,1,24.43,24.43,0,0,1-10.8-2.66l-.89-.42-.76-.37c-1.16-.56-2.33-1.12-3.54-1.62a5.37,5.37,0,0,0-.56-.21l-.09.47.44.2c1.08.51,2.14,1.09,3.2,1.67l.72.39,1.14.59a31.39,31.39,0,0,0,5.36,2.19,20.53,20.53,0,0,0,5.78.8,13.52,13.52,0,0,0,5.79-1,10.79,10.79,0,0,0,2.87-1.88l.26-.24a14.26,14.26,0,0,0,1.43-1.59c1.22-1.53,2.17-3.2,3.34-4.63a7.53,7.53,0,0,1,4.54-2.86,14.45,14.45,0,0,1,5.59.19,24.11,24.11,0,0,1,3.08.91l.88.33,1.41.59c.86.36,1.72.74,2.6,1.09l1.46.56c.43.15.86.3,1.3.43a16.86,16.86,0,0,0,4.18.71C538.11,170.3,538.05,170.05,538,169.8Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.1,116.46c-21.62,5.8-37.76,15.54-43.23,19.66-3.57,2.7-22.84,21.45-27.07,26.77-2.07,2.61,16.17,18.43,18.68,15.9,3.42-3.42,23.95-28.79,24.24-29.11,1.14-1.24,24.25-20.92,29.12-24.68C512,118.71,511.7,113.89,502.1,116.46Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.84,187.4a1.27,1.27,0,0,0,1.17.24c-.46,2.06-.32,3.82,1.12,4.47a2.34,2.34,0,0,0,2.56-.6A1.78,1.78,0,0,0,415,193.6c1.69.47,4.37-2.48,6.71-5.7-1.25,2.46-1.87,4.7-.36,5.19,4,1.27,8.46-6.5,12.21-11.33a20,20,0,0,1,4-4,4.63,4.63,0,0,1,.75-.41,1.54,1.54,0,0,1,1.81.08c.82.78-.38,3.1-1.63,4.33-2.36,2.33-3.3,7.35-1.86,8.85,2.11,2.2,6.83-3.86,9-5.56,2.9-2.28,5.84-8.44,6.15-8.79,0,0-.6-1.18-2.22-3.94-3.08-5.25-8.21-13.07-11.94-14.19a89.4,89.4,0,0,0-21.91,10.78C412.32,171.25,405.37,185,408.84,187.4Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,176.19a15.09,15.09,0,0,0-5,4.79c-1.82,2.66-2.24,4.45-3.54,7.25a.07.07,0,0,0,.12.05c.62-1.33,2.88-5.67,3.62-6.89a14.35,14.35,0,0,1,4.87-5.16S430,176.18,430,176.19Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.8,172.62a33.13,33.13,0,0,0-5.69,5.22c-2.08,2.41-3.24,5.44-4.4,8.37-.7,1.76-1.36,3.53-2,5.33,0,.07.09.13.12.05q1.74-4.51,3.75-8.92a22.71,22.71,0,0,1,5.16-7.24c1.25-1.16,1.74-1.71,3.07-2.77A0,0,0,1,0,425.8,172.62Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.91,169.39c-2.3,1.54-4.37,2.85-6,5.1a34.29,34.29,0,0,0-4.08,8.13c-.62,1.63-1.18,3.28-1.72,4.94,0,.06.09.11.11,0a90.57,90.57,0,0,1,4.56-10.74,14.18,14.18,0,0,1,2.9-4,31.6,31.6,0,0,1,4.28-3.44S421.92,169.39,421.91,169.39Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.31,193.09a1.46,1.46,0,0,1-.73-.74,2,2,0,0,1-.09-1,8.15,8.15,0,0,1,.6-2c.13-.33.27-.66.37-1,0,0,0-.06,0-.08s0,0,0-.07-.08-.1-.12-.09-.09.06-.12.08l-.05,0-.16.22-.3.45c-.39.59-.8,1.18-1.23,1.74a8.49,8.49,0,0,1-3.09,2.76,2.07,2.07,0,0,1-1.89-.12,1.29,1.29,0,0,1-.6-1.6l.26-.75-.59.54a2.41,2.41,0,0,1-1.62.67,1.55,1.55,0,0,1-1.45-.8,4.11,4.11,0,0,1-.44-1.79,5.51,5.51,0,0,1,.19-1.86l.13-.44-.43.19a1.19,1.19,0,0,1-1.09-.23,1.54,1.54,0,0,1-.64-1,7.82,7.82,0,0,1-.05-2.69,20.68,20.68,0,0,1,1.53-5.18,31.57,31.57,0,0,1,6-9.37,29.34,29.34,0,0,0-6.31,9.13,20.33,20.33,0,0,0-1.56,5.37,8.22,8.22,0,0,0,0,2.84,2.6,2.6,0,0,0,.27.7,1.62,1.62,0,0,0,.53.57,1.57,1.57,0,0,0,1.52.27l-.3-.26a6,6,0,0,0-.21,2,4.47,4.47,0,0,0,.51,2,1.82,1.82,0,0,0,.77.76,2.51,2.51,0,0,0,1,.24,2.88,2.88,0,0,0,1.9-.81l-.32-.2a1.71,1.71,0,0,0,0,1.18,1.67,1.67,0,0,0,.77.88,2.45,2.45,0,0,0,1.1.34,2.66,2.66,0,0,0,1.12-.21,9,9,0,0,0,3.17-2.93c.42-.58.82-1.18,1.2-1.78l.29-.45c.07-.15.29-.33.07-.28-.08.33-.22.67-.33,1a8.17,8.17,0,0,0-.54,2.08,2,2,0,0,0,.14,1.06A1.41,1.41,0,0,0,421.31,193.09Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.18,125l20.11,12.47a134.94,134.94,0,0,0,17.22-15c7.12-7.74-1.7-9.81-15.22-5.45S472.18,125,472.18,125Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.89,123.26c4.46,2.51,8.74,5.33,13,8.24,1.19.82,2.37,1.67,3.52,2.55a0,0,0,1,1,0,0c-2.2-1.3-4.34-2.69-6.49-4.07s-4.31-2.78-6.43-4.22c-1.2-.82-2.39-1.63-3.57-2.47C477.8,123.3,477.84,123.22,477.89,123.26Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.3,130.64c.07,0,.05-.12,0-.08-1,.56-1.93,1.16-2.88,1.77,1.74-1.51,3.42-3.09,5.08-4.7.07-.07,0-.19-.11-.12-2.21,1.74-4.42,3.48-6.58,5.3-1.06.89-5.34,4.53-5.48,4.56a11.77,11.77,0,0,1-1.16-.67c-.09,0-.17.08-.09.13.33.18,1.17.89,1.38.93a46.56,46.56,0,0,0,4.95-3.72l1.15-1h0C499.83,132.31,501.06,131.48,502.3,130.64Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.45,124.08c-3.15.54-8.48-3.47-11.3-7a61.83,61.83,0,0,1-.58-6.59c-.18-2.11-.44-4.46-.82-6.59l13.92.83a34.61,34.61,0,0,0,.19,8.39,4.32,4.32,0,0,0,.25.86s0,.09,0,.14C518.73,115.77,520.89,123.31,516.45,124.08Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.67,104.76s-.06.6-.11,1.54c-2.18,4.2-6.24,9.51-12.66,8.89-.08-1.19-.19-2.84-.33-4.66-.19-2.11-.43-4.46-.83-6.59Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517,85.56c2.33,4.45,2.41,18.56-.38,22.24-4,5.32-11.93,7.24-16.78,2.1s-4.47-23.38-1.24-26.85C503.37,77.94,513.57,79,517,85.56Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.77,96.2s.07,0,.07.08c0,1,.12,2,1,2.35,0,0,0,.06,0,.05C504.76,98.54,504.59,97.09,504.77,96.2Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.61,95.19c1.52-.13,1.67,2.94.26,3.06S504.33,95.3,505.61,95.19Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.56,96.67s-.08,0-.07.09c.1.94.05,2-.79,2.42,0,0,0,.06,0,0C499.75,99,499.8,97.55,499.56,96.67Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.64,95.74c-1.53,0-1.44,3.06,0,3.07S499.92,95.75,498.64,95.74Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.75,93.73a9.92,9.92,0,0,1-1.21-.36,2,2,0,0,1-1.16-.6.65.65,0,0,1,.06-.79,1.6,1.6,0,0,1,1.61-.24,2.35,2.35,0,0,1,1.41,1A.69.69,0,0,1,506.75,93.73Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.35,94.28a11.87,11.87,0,0,0,1.19-.4,2,2,0,0,0,1.14-.64.66.66,0,0,0-.09-.79,1.62,1.62,0,0,0-1.62-.19,2.36,2.36,0,0,0-1.38,1A.69.69,0,0,0,497.35,94.28Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.55,105c-.21.23-.43.55-.77.6a2.61,2.61,0,0,1-1-.19,0,0,0,0,0,0,0,1.27,1.27,0,0,0,1.23.45,1,1,0,0,0,.71-.87C506.66,105,506.58,105,506.55,105Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.41,102.21a3.21,3.21,0,0,1-2.08,1.54,3.78,3.78,0,0,1-1.16.11h-.23l-.2,0a.25.25,0,0,1-.21-.21h0a.31.31,0,0,1,0-.1h0v-.08c-.06-.73,0-1.85,0-1.85-.26.15-1.6.83-1.59.45a48.72,48.72,0,0,1,.77-9.85c0-.1.18-.09.17,0,.09,3-.36,6.09-.32,9.15a6.26,6.26,0,0,1,1.51-.54c.1,0-.07,2.16,0,2.48a.1.1,0,0,0,0,0,4.48,4.48,0,0,0,3.29-1.2C505.39,102.07,505.47,102.13,505.41,102.21Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.58,103.47a3.83,3.83,0,0,0,1.59,1.11,1.74,1.74,0,0,0,1.06,0c.74-.24.73-.93.56-1.52a4.4,4.4,0,0,0-.38-.9A5,5,0,0,1,502.58,103.47Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.17,104.58a1.74,1.74,0,0,0,1.06,0c.74-.24.73-.93.56-1.52A1.78,1.78,0,0,0,504.17,104.58Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#ff9cbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.57,89.54c5.45,2.84,11.71-3.22,11.71-3.22a5.52,5.52,0,0,0,6,2.79s2,8.41,4.27,8.12c3.42-.44,3.07-12.2,1.71-14.35s-4.33-2.39-4.33-2.39a5.64,5.64,0,0,0-2.75-3.1c-2.55-1.51-10.33,1.88-10.33,1.88a7.65,7.65,0,0,0-2.41-2.54,2.13,2.13,0,0,0-3,.66,5.1,5.1,0,0,1,1.08,2c.7,2.44-1.34,2.69-1.59.42a3.52,3.52,0,0,1,.51-2.42c-1.19-1.36-2.89-1.64-3.79-.73C491,78.32,491,87.18,495.57,89.54Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.68,97.48s2.36-4.94,4.55-4.17.94,7.57-1.27,8.84a2.43,2.43,0,0,1-3.43-.75Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.82,95.25a0,0,0,0,1,0,.06,6.1,6.1,0,0,0-2.5,4.32,1.34,1.34,0,0,1,1.92-.7.05.05,0,0,1,0,.1,1.51,1.51,0,0,0-1.54.79,7.17,7.17,0,0,0-.56,1.44c0,.16-.33.13-.3-.05v0C516.45,99.06,517.59,95.84,519.82,95.25Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.79,112.73,630,64.11a8,8,0,0,0,.59,2.41,8.65,8.65,0,0,0,1.49,2.34c4.7,5.41,17.16,8.37,37.14,8.83L673,126.31c-20-.46-32.45-3.43-37.15-8.83a9.19,9.19,0,0,1-1.48-2.34A7.51,7.51,0,0,1,633.79,112.73Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M633.79,112.73,630,64.11a8,8,0,0,0,.59,2.41,8.65,8.65,0,0,0,1.49,2.34c4.7,5.41,17.16,8.37,37.14,8.83L673,126.31c-20-.46-32.45-3.43-37.15-8.83a9.19,9.19,0,0,1-1.48-2.34A7.51,7.51,0,0,1,633.79,112.73Z",
    transform: "translate(-57.31 -38.95)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M634.27,105.74a15.46,15.46,0,0,1-.24,3.56,15.2,15.2,0,0,0-.24,3.43L630,64.11a15.71,15.71,0,0,1,.24-3.42,16.11,16.11,0,0,0,.25-3.56Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M634.27,105.74a15.46,15.46,0,0,1-.24,3.56,15.2,15.2,0,0,0-.24,3.43L630,64.11a15.71,15.71,0,0,1,.24-3.42,16.11,16.11,0,0,0,.25-3.56Z",
    transform: "translate(-57.31 -38.95)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M630.5,57.13l3.77,48.61a8,8,0,0,0-.71-2.75,9.51,9.51,0,0,0-1.48-2.27c-4.88-5.62-17.52-8.29-38.44-8.13L589.86,44c20.92-.17,33.56,2.5,38.44,8.12a9.37,9.37,0,0,1,1.48,2.28A8,8,0,0,1,630.5,57.13Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-238"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M570.57,66.36a20.64,20.64,0,0,1-34.49,13.06l-10.33,1.51L530.92,72a20.65,20.65,0,1,1,39.65-5.64Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.57,66.36a20.81,20.81,0,0,1-4.16,10.46A22.72,22.72,0,0,1,564.53,79a22.44,22.44,0,0,1-2.17,1.84,20.29,20.29,0,0,1-5,2.78,20.87,20.87,0,0,1-5.56,1.32A21.16,21.16,0,0,1,549,85a19.68,19.68,0,0,1-2.86-.3,20.87,20.87,0,0,1-10.21-5l.24.07L525.8,81.29l-.75.12.38-.66,5.14-9,0,.36a20.87,20.87,0,0,1,1.27-18.41,21.17,21.17,0,0,1,6.47-6.88,20.85,20.85,0,0,1,32.28,19.49Zm0,0A20.4,20.4,0,0,0,547.16,44a20.27,20.27,0,0,0-8.53,3.36,21.27,21.27,0,0,0-6.17,6.74,20.24,20.24,0,0,0-2.62,8.74,20.46,20.46,0,0,0,1.45,9l.07.19-.09.16-5.2,8.92-.37-.55L536,79.12l.14,0,.1.1a20.39,20.39,0,0,0,9.89,5.09,17.55,17.55,0,0,0,2.8.34,19.53,19.53,0,0,0,8.34-1.22,19.49,19.49,0,0,0,5-2.68,23.61,23.61,0,0,0,2.18-1.82,22.26,22.26,0,0,0,1.87-2.13A20.73,20.73,0,0,0,570.57,66.36Z",
    transform: "translate(-57.31 -38.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "490.31 37.04 481.49 28.11 484.45 25.18 489.61 30.4 500.31 13.62 503.82 15.86 490.31 37.04",
    style: {
      fill: "#407BFF"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamgoalsCuate);
export default __webpack_public_path__ + "static/media/Team goals-cuate.d9b1ec06c35baec8de497ae39a0e6bf0.svg";
export { ForwardRef as ReactComponent };